import { Component, OnInit } from '@angular/core';
import { PerformanceSummary } from '../../services/nswag/nswagclient';

@Component({
    selector: 'simulation-performance',
    templateUrl: './performance.component.html',
    styleUrls: ['../job-simulator/job-simulator.component.css'],
    standalone: false
})
export class PerformanceComponent implements OnInit {
  performanceSummary?: PerformanceSummary;

  constructor() { }

  ngOnInit() {
  }

}
